import { useQuery, UseQueryResult } from 'react-query';
import { queryKeys } from '../queryKeyFactory';
import { EmailPreferences } from '../../models/EmailPreferences';
import { fetchEmailPreferences } from '../../services/user/user.service';

interface UseFetchUserEmailPreferencesOptions {
  enabled?: boolean;
}

export default ({ enabled = true }: UseFetchUserEmailPreferencesOptions = {}): UseQueryResult<
  EmailPreferences,
  Error
> => useQuery([queryKeys.fetchEmailPrefrences], async () => fetchEmailPreferences(), { enabled });
